import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19631aae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "iconfont icon-onetabAvatar"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {"background-color":"rgba(250, 250, 250, 0.4)","opacity":"0.12"}
}, null, -1))
const _hoisted_4 = { class: "canter" }
const _hoisted_5 = ["onClick", "onContextmenu"]
const _hoisted_6 = {
  class: "iconfont icon-onetabgongxiangxiaobiaoshi",
  style: {"position":"absolute","font-size":"6px","bottom":"-8.5px","left":"13px"}
}
const _hoisted_7 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_8 = {
  class: "iconfont icon-onetabgongxiang",
  style: {"font-size":"10px","margin-left":"5px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-onetabicon-36" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

import { delCategory, removeShareCategory } from '@/api/baseApi';
import { RaMessageBox, RaMessage, RaTooltip } from '@rafter/pc';
import {
  ref,
} from 'vue';
import { user } from '../store/user';
import { bookmarks } from '@/store/bookmarks';
import { settings } from '@/store/settings';

export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
  style: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['handleSetting', 'getCheckedItem', 'handleAdd'],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;


const checked = ref(null);
const categories = bookmarks.categories;
const showMenu = ref(null);
const menuStyle = ref({ top: 0, left: 0, isShow: false });
const handleAdd = (event, isAdd = false) => {
  emits('handleAdd', isAdd ? null : showMenu.value);
  menuStyle.value.isShow = false;
};

const handleSetting = () => {
  emits('handleSetting');
};
const handleItem = (item) => {
  bookmarks.oldActive = bookmarks.categories.find((item) => item.active);
  bookmarks.setActive(item);
};
const refreshCategories = () => {};
const handleMenu = (e, item) => {
  e.preventDefault();

  const rect = e.target.classList.contains('iconfont')
    ? e.target.parentNode.getBoundingClientRect()
    : e.target.getBoundingClientRect();
  console.log(e, e.target, rect);

  menuStyle.value.left = rect.right + 12;
  menuStyle.value.top = rect.bottom + 5;

  showMenu.value = item;
  menuStyle.value.isShow = true;
};
const handleDelete = () => {
  if(bookmarks.categories.length <= 1){
    RaMessage({
      type: 'error',
      message: '至少需要保留一个分类',
    });
    return;
  }
  RaMessageBox.confirm('确定删除吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      const delFunc = () =>{
        const index = bookmarks.categories.findIndex((item) => item.uuid === showMenu.value.uuid);
        const sum = bookmarks.categories.length - 1;
        let nextIndex = 0;
        if(index === sum){
          nextIndex = sum - 1;
        }else{
          nextIndex = index + 1;
        }
        bookmarks.setActive(bookmarks.categories[nextIndex]);
        
        delCategory(showMenu.value.uuid).then((res) => {
          RaMessage({
            type: 'success',
            message: '删除成功',
          });
          bookmarks.delCategory(showMenu.value.uuid);
          menuStyle.value.isShow = false;
        });
      }
      if(!showMenu.value.is_owner){
        removeShareCategory({
          category_uuid: showMenu.value.uuid,
        }).then(res => {
          if(res.data.code === 200){
            delFunc();
          }else{
            RaMessage({
              type: 'error',
              message: '删除失败，请重试',
            });
          }
        }).catch(err=>{
          RaMessage({
            type: 'error',
            message: '删除失败，请重试',
          });
        });
      }else{
        delFunc();
      }
    })
    .catch((err) => {
      RaMessage({
        type: 'info',
        message: '取消删除',
      });
    });
};

__expose({ refreshCategories });

const handleCloseMenu = () => {
  menuStyle.value.isShow = false;
};

return (_ctx: any,_cache: any) => {
  const _directive_clickoutside = _resolveDirective("clickoutside")!

  return (_openBlock(), _createElementBlock("div", {
    class: "side",
    style: _normalizeStyle(props.style)
  }, [
    _createElementVNode("div", {
      class: "avatar",
      onClick: handleSetting
    }, [
      (!_unref(user).token)
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _unref(user).avatar
          }, null, 8, _hoisted_2))
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookmarks).categories, (item) => {
        return (_openBlock(), _createBlock(_unref(RaTooltip), {
          key: item.uuid,
          placement: "right",
          trigger: "hover"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(item.name), 1),
              _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [
                [_vShow, item.is_share]
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({ item: true, active: item.active }),
              onClick: ($event: any) => (handleItem(item)),
              onContextmenu: ($event: any) => (handleMenu($event, item))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(`side-icon-${item.uuid} iconfont ${item.icon}`)
              }, null, 2),
              _withDirectives(_createElementVNode("i", _hoisted_6, null, 512), [
                [_vShow, item.is_share]
              ])
            ], 42, _hoisted_5)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _hoisted_9,
    _createElementVNode("div", {
      class: "setting",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAdd($event, true)))
    }, _hoisted_11),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "item-menu",
        style: _normalizeStyle({
          top: `${menuStyle.value.top}px`,
          left:
            _unref(settings).sideColumnPosition === 0
              ? `${menuStyle.value.left}px`
              : `${menuStyle.value.left - 110}px`,
        })
      }, [
        (showMenu.value && !showMenu.value.share_origin_uuid)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "text",
              onClick: handleAdd
            }, "编辑"))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "text",
          onClick: handleDelete
        }, "删除")
      ], 4)), [
        [_vShow, menuStyle.value.isShow],
        [_directive_clickoutside, handleCloseMenu]
      ])
    ]))
  ], 4))
}
}

})